import * as React from 'react';

import { cn } from '../../lib/cn';

// Label, bar, "n / total" per row, the bars scaled to the largest. The largest row
// is the one to act on, so by default it carries the failure colour; `worst={false}`
// keeps every bar grey where the page's note already does the pointing.
export const BarRows = React.forwardRef(
  ({ className, rows = [], total, worst = true, ...props }, ref) => {
    const max = Math.max(0, ...rows.map((row) => row.value || 0));
    const denominator = total ?? rows.reduce((sum, row) => sum + (row.value || 0), 0);
    return (
      <div
        ref={ref}
        className={cn(
          'grid grid-cols-[minmax(0,190px)_1fr_72px] items-center gap-x-3 gap-y-[9px] font-dusq text-[12px]',
          className
        )}
        {...props}
      >
        {rows.map((row) => (
          <React.Fragment key={row.key ?? row.label}>
            <span className="min-w-0 text-dusq-emphasis-disabled">
              {row.label}
              {row.sub && <span className="block text-[11px] text-dusq-text-muted">{row.sub}</span>}
            </span>
            <span className="h-2 overflow-hidden rounded-[2px] bg-dusq-grey900">
              <span
                className={cn(
                  'block h-full',
                  worst && row.value === max && max > 0 ? 'bg-dusq-negative' : 'bg-dusq-grey400'
                )}
                style={{ width: max > 0 ? `${Math.max(1, ((row.value || 0) / max) * 100)}%` : 0 }}
              />
            </span>
            <span className="text-right text-dusq-grey400">
              <span className="font-medium text-dusq-text">{row.value}</span>
              {` / ${denominator}`}
            </span>
          </React.Fragment>
        ))}
      </div>
    );
  }
);
BarRows.displayName = 'BarRows';
